import React, { Component, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { string, bool, arrayOf, shape, func } from 'prop-types';

import urlEncode from '../components/urlEncode';
import filterStations from './filterStations';
import Navigation from '../components/Navigation';
import Genres from '../components/Genres';
import Stations from '../components/Stations';
import StationModal from '../components/StationModal';
import StationPlayer from '../components/StationPlayer';

class Feed extends Component {
  componentDidMount() {
    const { match, showModal } = this.props;
    if (match.params.action === 'about') {
      showModal();
    }
  }

  render() {
    const {
      terms,
      loadingGenres,
      loadingStations,
      stations,
      genres,
      match,
      showModal,
      hideModal,
      modalIsVisible,
      playerIsVisible,
      playStation,
      pauseStation,
      isPlaying,
      currentlyPlaying,
      setPlayer,
      closePlayer,
      player
    } = this.props;
    const { params } = match;

    const genre = genres.filter(
      item =>
        urlEncode(item.name).toUpperCase() === params.filterName.toUpperCase()
    )[0];

    const filteredStations = filterStations(
      params.filterName,
      params.pageType,
      stations,
      genre
    );

    return (
      <Fragment>
        <Navigation
          terms={terms}
          loadingGenres={loadingGenres}
          loadingStations={loadingStations}
          genre={genre || {}}
          genres={genres}
          stations={stations}
          match={match}
          showModal={showModal}
        />
        {params.pageType === 'genres' ? (
          <Genres terms={terms} loadingGenres={loadingGenres} genres={genres} />
        ) : (
          <Stations
            terms={terms}
            loadingStations={loadingStations}
            playStation={playStation}
            pauseStation={pauseStation}
            isPlaying={isPlaying}
            match={match}
            filteredStations={filteredStations}
            showModal={showModal}
            hideModal={hideModal}
            currentlyPlaying={currentlyPlaying}
          />
        )}
        {playerIsVisible && (
          <StationPlayer
            station={currentlyPlaying}
            isPlaying={isPlaying}
            setPlayer={setPlayer}
            closePlayer={closePlayer}
            player={player}
          />
        )}
        <Route
          path={`${match.url}/:stationName`}
          render={subProps => (
            <StationModal
              stations={stations}
              playStation={playStation}
              terms={terms}
              loadingStations={loadingStations}
              match={subProps.match}
              modalIsVisible={modalIsVisible}
              hideModal={hideModal}
            />
          )}
        />
      </Fragment>
    );
  }
}

Feed.propTypes = {
  terms: arrayOf(string).isRequired,
  loadingGenres: bool.isRequired,
  loadingStations: bool.isRequired,
  stations: arrayOf(shape).isRequired,
  genres: arrayOf(shape).isRequired,
  playStation: func.isRequired,
  pauseStation: func.isRequired,
  isPlaying: bool.isRequired,
  match: shape().isRequired,
  showModal: func.isRequired,
  hideModal: func.isRequired,
  modalIsVisible: bool.isRequired,
  playerIsVisible: bool.isRequired,
  currentlyPlaying: shape().isRequired,
  setPlayer: func.isRequired,
  closePlayer: func.isRequired,
  player: shape().isRequired
};

export default Feed;
